export default "__VITE_ASSET__2e276f46__"